// Resolve a character's /ogs bundle file to a browsable URL (served by the AAM,
// same rows ogsContentPacks mounts). `import.meta.env?.` so plain-node tests can import.
const BASE = import.meta.env?.VITE_ASSET_MANAGER_URL || 'http://localhost:8081'

export function ogsFileHref(charId, filename, base = BASE) {
  if (!charId || !filename) return null
  return `${base}/api/characters/${encodeURIComponent(charId)}/ogs/${encodeURIComponent(filename)}`
}
